import React, { useContext } from 'react'
import { Modal, Button, Typography } from 'antd'
import { useIntl } from 'react-intl'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { RechargeType } from '@vacationtracker/shared/types/recharge-type'
import { getRechargeTypeInfo, getRechargeTypeDisplayName } from '../../util/recharge-type-info'
import { ThemeContext } from '../../context/themeContext'
import IntlMessages from '../../util/IntlMessages'

import './styles.less'

const { Title, Text } = Typography

interface RechargeTypeIntroModalProps {
  visible: boolean
  currentRechargeType?: RechargeType | null
  onStartQuiz: () => void
  onCancel: () => void
}

const rechargeTypes = [RechargeType.DEEP_RESTORER, RechargeType.SOCIAL_SPRINTER, RechargeType.STRUCTURED_SOCIALIZER, RechargeType.SPONTANEOUS_SOLOIST]

export const RechargeTypeIntroModal: React.FC<RechargeTypeIntroModalProps> = ({ visible, currentRechargeType, onStartQuiz, onCancel }) => {
  const { formatMessage } = useIntl()
  const { theme } = useContext(ThemeContext)
  const isDark = theme === DARK_THEME
  const isRetakeMode = !!currentRechargeType

  return (
    <Modal open={visible} onCancel={onCancel} footer={null} width={560} centered className={`recharge-intro-modal ${isDark ? 'dark' : ''}`} closable={true}>
      <div className="recharge-intro-content">
        <Title level={3} className="recharge-intro-title">
          <IntlMessages id={isRetakeMode ? 'rechargeType.prompt.introModal.titleRetake' : 'rechargeType.prompt.introModal.title'} />
        </Title>
        <Text className="recharge-intro-subtitle">
          <IntlMessages id={isRetakeMode ? 'rechargeType.prompt.introModal.subtitleRetake' : 'rechargeType.prompt.introModal.subtitle'} />
        </Text>

        <div className="recharge-intro-types">
          {rechargeTypes.map((type) => {
            const info = getRechargeTypeInfo(type, formatMessage)
            const name = getRechargeTypeDisplayName(type, formatMessage)
            const isCurrentType = currentRechargeType === type
            return (
              <div key={type} className={`recharge-intro-type-card ${isDark ? 'dark' : ''} ${isCurrentType ? 'current' : ''}`}>
                <span className="recharge-intro-type-emoji">{info.emoji}</span>
                <div className="recharge-intro-type-info">
                  <Text strong className="recharge-intro-type-name">
                    {name}
                    {isCurrentType && (
                      <span className="you-badge">
                        <IntlMessages id="rechargeType.prompt.introModal.youBadge" />
                      </span>
                    )}
                  </Text>
                  <Text className="recharge-intro-type-tagline">{info.tagline}</Text>
                </div>
              </div>
            )
          })}
        </div>

        <Button type="primary" size="large" block onClick={onStartQuiz} className="recharge-intro-button">
          <IntlMessages id={isRetakeMode ? 'rechargeType.prompt.introModal.retakeQuiz' : 'rechargeType.prompt.introModal.findMyType'} />
        </Button>

        {!isRetakeMode && (
          <Text className="recharge-intro-footer">
            <IntlMessages id="rechargeType.prompt.introModal.footer" />
          </Text>
        )}
      </div>
    </Modal>
  )
}
